import { useState } from 'react';

function PrintingProgressGrid({
  items = [],
  status,
  onSelectSchool,
  title,
  description,
}) {
  const [sortKey, setSortKey] = useState('pendingCards');
  const [sortOrder, setSortOrder] = useState('desc');

  const sortedItems = [...items].sort((a, b) => {
    let valA = a[sortKey];
    let valB = b[sortKey];

    if (typeof valA === 'string') {
      valA = valA.toLowerCase();
      valB = valB.toLowerCase();
    }

    if (valA < valB) return sortOrder === 'asc' ? -1 : 1;
    if (valA > valB) return sortOrder === 'asc' ? 1 : -1;
    return 0;
  });

  return (
    <div className="progress-section">
      <div className="progress-header">
        <div className="header-content">
          {(title || description) && (
            <div>
              {title && <h2>{title}</h2>}
              {description && <p>{description}</p>}
            </div>
          )}
          {status?.type === 'loading' && (
            <span className="tag neutral">جاري التحديث...</span>
          )}
        </div>

        <div className="grid-controls">
          <div className="sort-group">
            <span>ترتيب حسب:</span>
            <select
              value={sortKey}
              onChange={(e) => setSortKey(e.target.value)}
              className="sort-select"
            >
              <option value="schoolName">اسم المدرسة</option>
              <option value="totalCards">إجمالي البطاقات</option>
              <option value="completedCards">البطاقات المكتملة</option>
              <option value="pendingCards">البطاقات المتبقية</option>
            </select>
            <button
              type="button"
              className="sort-order-btn"
              onClick={() =>
                setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
              }
              title={sortOrder === 'asc' ? 'تنازلي' : 'تصاعدي'}
            >
              {sortOrder === 'asc' ? '↑' : '↓'}
            </button>
          </div>
        </div>
      </div>

      {status?.type === 'error' && (
        <div className="status-message error">{status?.message}</div>
      )}

      <div className="progress-grid">
        {sortedItems.map((item) => {
          const rate = Number(item.completionRate ?? 0);
          return (
            <article className="progress-card" key={item.schoolObjectId}>
              <div className="progress-card__header">
                <div>
                  <h3>{item.schoolName}</h3>
                  <p>{item.groupName}</p>
                </div>
              </div>

              <div className="progress-chart">
                <div className="progress-chart__label">
                  التقدم الحالي
                  <strong>{rate.toFixed(2)}%</strong>
                </div>
                <div className="progress-chart__bar">
                  <div
                    className="progress-chart__value"
                    style={{ width: `${Math.min(rate, 100)}%` }}
                  />
                </div>
              </div>

              <div className="progress-details">
                <div>
                  <strong>{item.totalCards}</strong>
                  <span>إجمالي البطاقات</span>
                </div>
                <div>
                  <strong>{item.completedCards}</strong>
                  <span>المكتملة</span>
                </div>
                <div>
                  <strong>{item.pendingCards}</strong>
                  <span>قيد الانتظار</span>
                </div>
              </div>

              <button
                type="button"
                className="primary outline"
                onClick={() =>
                  onSelectSchool?.({
                    _id: item.schoolObjectId,
                    schoolName: item.schoolName,
                    groupName: item.groupName,
                    schoolCode: item.schoolCode,
                  })
                }
              >
                عرض تفاصيل المدرسة
              </button>
            </article>
          );
        })}
      </div>
    </div>
  );
}

export default PrintingProgressGrid;

